import React from "react";
import { Box, Typography } from "@dealer-center/core-components";
import { CONTAINER_STYLES, TYPOGRAPHY_STYLES } from "../styleConstants";

interface SectionHeaderProps {
  title: string;
  className?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  className = "section-header"
}) => (
  <Box
    className={className}
    sx={{
      ...CONTAINER_STYLES.flexRowCenter,
      marginBottom: 3
    }}
  >
    <Typography sx={TYPOGRAPHY_STYLES.sectionHeader} variant="h5">
      {title}
    </Typography>
  </Box>
);
